import React, { useContext } from "react"
import { Modal } from "react-bootstrap";
import {
  Button,
  TextField,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import language from "../../../nls/language.json";
import Context from "../../../context/Context";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import '../MessageSector.css';

export default function EditMensagemModal({
  showModalEdit,
  setShowModalEdit,
  selectedMessage,
  handleEditMessage,
  putMessageSector,
  allSectors
}) {
  const {
    selectedCountry,
  } = useContext(Context);

  return (
    <Modal show={showModalEdit} onHide={() => setShowModalEdit(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {language[selectedCountry.name].Cadastro.mensagemSetor.modal.editar.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column">
          <FormControlLabel
            className="w-50"
            control={
              <Checkbox
                checked={selectedMessage.mensagem_Ativo}
                onChange={(e) => handleEditMessage({ name: "mensagem_Ativo", value: e.target.checked})}
              />}
            label={"ATIVAR MENSAGEM"}
          />
          <div className="d-flex flex-row">
            <TextField
              className="mt-2 mb-3 w-100"
              label="Mensagem"
              name="mensagem_Texto"
              required
              fullWidth
              id="outlined-basic"
              placeholder="Mensagem"
              value={selectedMessage.mensagem_Texto}
              disabled={!selectedMessage.mensagem_Ativo}
              onChange={({ target }) => handleEditMessage({
                name: "mensagem_Texto",
                value: target.value.toUpperCase()
              })}
            />
          </div>
          <div className="d-flex flex-row">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Data Início"
                format="DD/MM/YYYY"
                value={dayjs(selectedMessage.mensagem_DataInicio)}
                disabled={!selectedMessage.mensagem_Ativo}
                onChange={(e) => handleEditMessage({ name: "mensagem_DataInicio", value: new Date(e.$d) })}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                label="Hora Início"
                ampm={false}
                value={dayjs(selectedMessage.mensagem_DataInicio)}
                disabled={!selectedMessage.mensagem_Ativo}
                onChange={(e) => {
                  const date = new Date(selectedMessage.mensagem_DataInicio)
                  date.setHours((e.$H))
                  date.setMinutes(e.$m)
                  handleEditMessage({ name: "mensagem_DataInicio", value: date })
                }}
              />
            </LocalizationProvider>
          </div>
          <div className="d-flex flex-row mt-2">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Data Fim"
                format="DD/MM/YYYY"
                value={dayjs(selectedMessage.mensagem_DataFim)}
                disabled={!selectedMessage.mensagem_Ativo}
                onChange={(e) => handleEditMessage({ name: "mensagem_DataFim", value: new Date(e.$d) })}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                label="Hora Fim"
                ampm={false}
                value={dayjs(selectedMessage.mensagem_DataFim)}
                disabled={!selectedMessage.mensagem_Ativo}
                onChange={(e) => {
                  const date = new Date(selectedMessage.mensagem_DataFim)
                  date.setHours((e.$H))
                  date.setMinutes(e.$m)
                  handleEditMessage({ name: "mensagem_DataFim", value: date })
                }}
              />
            </LocalizationProvider>
          </div>
          <FormControlLabel
            className="w-50"
            control={
              <Checkbox
                checked={selectedMessage.isagA_Mensagem_Setores.length === allSectors.length}
                disabled={!selectedMessage.mensagem_Ativo}
                onChange={(e) => handleEditMessage(
                  { name: "msgSetor_Setor", value: allSectors },
                  e.target.checked ? "ALL" : "ALL_REMOVE")}
              />}
            label={"SELECIONAR TODOS"}
          />
          <div className="d-flex flex-row mt-2 flex-wrap justify-content-between">
            {allSectors.length && allSectors.map((item, index) => (
              <FormControlLabel
                className="w-25"
                key={`checkbox-add-message${index}`}
                control={
                  <Checkbox
                    checked={selectedMessage.isagA_Mensagem_Setores?.some(message => message?.msgSetor_Setor === item.stR_description)}
                    disabled={!selectedMessage.mensagem_Ativo}
                    onChange={(e) => handleEditMessage(
                      { name: "msgSetor_Setor", value: item.stR_description },
                      e.target.checked ? "ADD" : "REMOVE")
                    }
                  />}
                label={item.stR_description}
              />
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="text"
          sx={{ marginRight: 2 }}
          onClick={() => {
            setShowModalEdit(false);
          }}
        >
          {language[selectedCountry.name].Cadastro.mensagemSetor.modal.editar.btnCancelar}
        </Button>
        <Button
          variant="contained"
          onClick={() => putMessageSector(selectedMessage)}
        >
          {language[selectedCountry.name].Cadastro.mensagemSetor.modal.editar.btnSalvar}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

